<template>
    <div class="side-text">
        <hr :class="gold ? 'text-gold-500' : 'text-white'">
        <div class="text-base uppercase tracking-wide py-8">
            <slot name="title-text"></slot>
        </div>
        <div class="uppercase tracking-widest leading-normal">
            <slot name="subtitle-text"></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SectionSideText',
  props: {
    gold: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>

<style scoped>

</style>
